import { fetchZendeskToken } from '../../api/zendesk'
import { useAuthQuery } from '@/hooks/use-auth-query'

const useGetZendeskToken = () => {
  return useAuthQuery({
    queryKey: ['zendesk-token'],
    queryFn: fetchZendeskToken,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  })
}

export default useGetZendeskToken
